import angular from "angular";
import LibraryTariffsPageComponent from "./library-tariffs-page/library-tariffs-page.component";
import TariffFormComponent from "./tariff-form/tariff-form";

const LibraryTariffsModule = angular
  .module("modules.libraryTariffs", [])
  .component("libraryTariffsPage", LibraryTariffsPageComponent)
  .component("tariffForm", TariffFormComponent);

export default LibraryTariffsModule;
